import PropTypes from 'prop-types';
import BaseMenuItem from './BaseMenuItem';
import MenuItemDialog from './MenuItemDialog';

const MenuItemWithDialog = ({
                              icon,
                              title,
                              label,
                              onClick,
                              isLoading,
                              isSuccess,
                              isFailed,
                              isDisabled,
                              buttonAlign,

                              dialogTitle,
                              dialogSubtitle,
                              dialogIsOpen,
                              dialogHandleClose,
                              dialogOptions,
                              dialogAdditionalOptions,
                              dialogActions,
                            }) => {
  return <>
    <BaseMenuItem
      icon={icon}
      title={title}
      label={label}
      onClick={onClick}
      isLoading={isLoading}
      isSuccess={isSuccess}
      isFailed={isFailed}
      isDisabled={isDisabled}
      buttonAlign={buttonAlign}
    />

    <MenuItemDialog
      title={dialogTitle}
      subtitle={dialogSubtitle}
      isOpen={dialogIsOpen}
      isLoading={isLoading}
      handleClose={dialogHandleClose}
      options={dialogOptions}
      additionalOptions={dialogAdditionalOptions}
      dialogActions={dialogActions}
    />
  </>;
};

MenuItemWithDialog.propTypes = {
  onClick: PropTypes.func,
};

export default MenuItemWithDialog;
